import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import AddBtn from "../../Assets/addIcon.png";
import RemoveBtn from "../../Assets/removeIcon.png";
import "./newMenuCard.scss";

const SizeCustomizationModal = ({ isOpen, onClose, item, isGuestUser }) => {
  const dispatch = useDispatch();

  // 1. Connect to the active Redux cart to track quantities live
  const cart = useSelector((state) => state?.user.cart || {});

  const validOptions =
    item?.menuSizeOptions?.filter((opt) => opt.isActive !== false) || [];

  const [selectedOption, setSelectedOption] = useState(null);

  // Set default option to lowest price variant when modal opens
  useEffect(() => {
    if (validOptions.length > 0) {
      const defaultOption = validOptions.reduce(
        (min, opt) => (opt.price < min.price ? opt : min),
        validOptions[0],
      );
      setSelectedOption(defaultOption);
    }
  }, [item, isOpen]);

  if (!isOpen || !item) return null;

  // Helper to generate the unique compound key used by Redux
  const getCartKey = (optionId) => `${item.menuId}_${optionId}`;

  // Get the current quantity of the selected option from the cart
  const currentCartItem = selectedOption
    ? cart[getCartKey(selectedOption.sizeOptionId)]
    : null;
  const quantityInCart = currentCartItem ? currentCartItem.selected : 0;

  // 2. Quantity Modifier Handlers linked to Redux Actions
  const handleIncrement = () => {
    if (!selectedOption) return;
    dispatch({
      type: "ADD_ITEM_MENU",
      payload: {
        id: item.menuId,
        selectedTab: item.categoryId || item.selectedTab, // Fallback safety
        variant: {
          sizeOptionId: selectedOption.sizeOptionId,
          sizeName: selectedOption.sizeName,
          price: selectedOption.price,
        },
      },
    });
  };

  const handleDecrement = () => {
    if (!selectedOption || quantityInCart === 0) return;
    dispatch({
      type: "REMOVE_ITEM_MENU",
      payload: {
        cartKey: getCartKey(selectedOption.sizeOptionId),
        id: item.menuId,
      },
    });
  };

  return (
    <div className="variant-modal-overlay" onClick={onClose}>
      <div
        className="variant-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Modal Header */}
        <div className="variant-modal-header">
          <div>
            <h3>Customize {item.foodName}</h3>
            <p className="variant-subtext">Quantity Options</p>
          </div>
          <button className="variant-modal-close" onClick={onClose}>
            &times;
          </button>
        </div>

        {/* Variant Options List */}
        <div className="variant-modal-body">
          {validOptions.map((option) => {
            const isSelected =
              selectedOption?.sizeOptionId === option.sizeOptionId;
            const optionCartKey = getCartKey(option.sizeOptionId);
            const optionCount = cart[optionCartKey]?.selected || 0;

            return (
              <label
                key={option.sizeOptionId}
                className={`variant-option-row ${isSelected ? "selected" : ""}`}
              >
                <div className="variant-radio-group">
                  {isGuestUser !== true && (
                    <input
                      type="radio"
                      name="food-variant-size"
                      checked={isSelected}
                      onChange={() => setSelectedOption(option)}
                    />
                  )}
                  <span className="variant-name">
                    {option.sizeName}
                    {optionCount > 0 && (
                      <span className="variant-count-badge">
                        {" "}
                        ({optionCount} added)
                      </span>
                    )}
                  </span>
                </div>
                <span className="variant-price">₹{option.price}</span>
              </label>
            );
          })}
        </div>

        {/* 3. DYNAMIC FOOTER: Shows Add Button or Multi-Counter based on state */}

        {isGuestUser !== true && (
          <div className="variant-modal-footer">
            <div className="modal-counter-container">
              <span className="modal-counter-label">
                Quantity for {selectedOption?.sizeName}:
              </span>
              <div className="menuSelectItem">
                <button type="button" className="quantityActionBtn" onClick={handleDecrement} aria-label="Decrease quantity">
                  <img src={RemoveBtn} alt="" className="addRemoveIcon" />
                </button>
                <span className="selectNum">{quantityInCart}</span>
                <button type="button" className="quantityActionBtn" onClick={handleIncrement} aria-label="Increase quantity">
                  <img src={AddBtn} alt="" className="addRemoveIcon" />
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SizeCustomizationModal;
